export default __webpack_public_path__ + "static/media/element_80.185602be.webp";